import React from 'react';
import "./NotFound.css";

export default () => (
	<div className="NotFound">
		<h3>Sorry, this page doesn't exist.</h3>
	</div>
)